export const badWords = [
    "arse",
    "ass",
    "asshole",
    "bastard",
    "bitch",
    "bollocks",
    "brotherfucker",
    "bugger",
    "bullshit",
    "child-fucker",
    "Christ on a bike",
    "Christ on a cracker",
    "crap",
    "cunt",
    "damn",
    "effing",
    "fatherfucker",
    "frigger",
    "fuck",
    "goddamn",
    "godsdamn",
    "hell",
    "holy shit",
    "horseshit",
    "Jesus Christ",
    "Jesus fuck",
    "Jesus H. Christ",
    "Jesus Harold Christ",
    "Jesus wept",
    "Jesus, Mary and Joseph",
    "Judas Priest",
    "motherfucker",
    "nigga",
    "prick",
    "shit",
    "shit ass",
    "shitass",
    "sisterfucker",
    "slut",
    "son of a bitch",
    "son of a whore",
    "sweet Jesus",
    "twat",
    "suck",
    "sucker",
    "fucker"
];
